import Acessogov from './Acessogov';

export default Acessogov;
